// Single source of truth for all geo pricing.
// The exact same object drives BOTH landing page display AND checkout amount.

export const PRICING = {
  IN: {
    single: { amount: 49, currency: 'INR', symbol: '₹', display: '₹49' },
    solo:   { amount: 199, currency: 'INR', symbol: '₹', display: '₹199/mo' },
    family: { amount: 399, currency: 'INR', symbol: '₹', display: '₹399/mo' },
  },
  US: {
    single: { amount: 2.99, currency: 'USD', symbol: '$', display: '$2.99' },
    solo:   { amount: 4.99, currency: 'USD', symbol: '$', display: '$4.99/mo' },
    family: { amount: 9.99, currency: 'USD', symbol: '$', display: '$9.99/mo' },
  },
  GB: {
    single: { amount: 1.99, currency: 'GBP', symbol: '£', display: '£1.99' },
    solo:   { amount: 3.99, currency: 'GBP', symbol: '£', display: '£3.99/mo' },
    family: { amount: 7.99, currency: 'GBP', symbol: '£', display: '£7.99/mo' },
  },
  AE: {
    single: { amount: 9.99, currency: 'AED', symbol: 'AED', display: 'AED 9.99' },
    solo:   { amount: 18.99, currency: 'AED', symbol: 'AED', display: 'AED 18.99/mo' },
    family: { amount: 34.99, currency: 'AED', symbol: 'AED', display: 'AED 34.99/mo' },
  },
  AU: {
    single: { amount: 3.99, currency: 'AUD', symbol: 'A$', display: 'A$3.99' },
    solo:   { amount: 6.99, currency: 'AUD', symbol: 'A$', display: 'A$6.99/mo' },
    family: { amount: 12.99, currency: 'AUD', symbol: 'A$', display: 'A$12.99/mo' },
  },
  BR: {
    single: { amount: 5.99, currency: 'BRL', symbol: 'R$', display: 'R$5.99' },
    solo:   { amount: 12.99, currency: 'BRL', symbol: 'R$', display: 'R$12.99/mo' },
    family: { amount: 19.99, currency: 'BRL', symbol: 'R$', display: 'R$19.99/mo' },
  },
  DE: {
    single: { amount: 1.99, currency: 'EUR', symbol: '€', display: '€1.99' },
    solo:   { amount: 3.99, currency: 'EUR', symbol: '€', display: '€3.99/mo' },
    family: { amount: 7.99, currency: 'EUR', symbol: '€', display: '€7.99/mo' },
  },
  DEFAULT: {
    single: { amount: 2.99, currency: 'USD', symbol: '$', display: '$2.99' },
    solo:   { amount: 4.99, currency: 'USD', symbol: '$', display: '$4.99/mo' },
    family: { amount: 9.99, currency: 'USD', symbol: '$', display: '$9.99/mo' },
  },
};

// Extend Europe defaults to common EU country codes (all use EUR)
const EU_COUNTRIES = ['FR', 'IT', 'ES', 'NL', 'BE', 'AT', 'PT', 'IE', 'FI', 'GR', 'LU', 'SK', 'SI', 'EE', 'LV', 'LT', 'CY', 'MT'];
EU_COUNTRIES.forEach((cc) => { PRICING[cc] = PRICING.DE; });

export function getPricingForCountry(countryCode) {
  if (!countryCode) return PRICING.DEFAULT;
  return PRICING[countryCode.toUpperCase()] || PRICING.DEFAULT;
}

export async function detectPricing() {
  try {
    const ctrl = new AbortController();
    const t = setTimeout(() => ctrl.abort(), 3500);
    const res = await fetch('https://ipapi.co/json/', { signal: ctrl.signal });
    clearTimeout(t);
    if (!res.ok) throw new Error('bad status');
    const data = await res.json();
    const cc = data.country_code;
    return {
      country: cc || 'DEFAULT',
      country_name: data.country_name || '',
      pricing: getPricingForCountry(cc),
    };
  } catch (e) {
    return { country: 'DEFAULT', country_name: '', pricing: PRICING.DEFAULT };
  }
}
